// extracted by mini-css-extract-plugin
export default {"table":"Trainings_table__JoUkA","add":"Trainings_add__YmVxW"};